import { Listbox as HeadlessListbox, ListboxOptionProps } from "@headlessui/react";
import { useColorSchemeFn } from "@ugitgud/legos/hooks/useColorScheme";
import { BaseOptionValueType, WithClassName, WithColorScheme } from "@ugitgud/legos/ui/shared";
import { DropdownColorSchemes, DropdownOptionType } from "@ugitgud/legos/ui/form/dropdown/types";
import React from "react";

export type DropdownOptionProps<T extends DropdownOptionType<BaseOptionValueType>> = Omit<
  WithClassName<WithColorScheme<ListboxOptionProps<"li", T>, DropdownColorSchemes>>,
  "value"
> & {
  value: T;
};

export const DropdownOption = React.forwardRef(function <T extends DropdownOptionType<BaseOptionValueType>>(
  { value, className, colorScheme, ...rest }: DropdownOptionProps<T>,
  ref?: React.ForwardedRef<HTMLLIElement>,
) {
  const scheme = useColorSchemeFn({
    classes: {
      secondary:
        "dark:bg-purple-400 hover:dark:bg-lavender-500 dark:ui-not-selected:ui-not-active:text-lavender-50 dark:ui-active:bg-lavender-500 dark:ui-selected:bg-lavender-500",
    },
    common:
      "py-2 px-3 w-auto cursor-pointer font-normal ui-active:font-semibold ui-selected:font-semibold min-w-fit group ui-disabled:cursor-not-allowed dark:ui-not-selected:ui-not-active:ui-disabled:text-lavender-50/30",
    default: "secondary",
    className,
    scheme: colorScheme,
  });

  return <HeadlessListbox.Option ref={ref} value={value} disabled={value.unavailable} {...rest} className={scheme} />;
});
